<template>
  <div>
    <BaseLoadingBar v-if="pending && !error" />
    <div class="page-admin-user-profile__main">
      <LargeNotice
        v-if="error"
        @click="refresh"
        icon="✋"
        title="Oops!"
        :subtitle="$t('login.unknown-error')"
        :buttonText="$t('actions.refresh')"
        buttonIcon="refresh-cw"
      />
      <div class="page-admin-user-profile__content" v-if="!pending && !error">
        <div class="page-admin-user-profile__basic-form">
          <div class="page-admin-user-profile__basic-form-content">
            <PreferencesBasicInfo :currentUser="userPreferences" />
            <PreferencesForm :currentUser="userPreferences" />
            <PreferencesPasswordForm :userId="userPreferences.userId" />
          </div>
        </div>
        <div class="page-admin-user-profile__password-form">
          <div class="page-admin-user-profile__extension-card" v-if="tenantHasChromeExtensionAccess()">
            <div class="page-admin-user-profile__card-title">{{ $t('page.admin-user-profile.extension') }}</div>
            <div class="page-admin-user-profile__extension-options">
              <div class="page-admin-user-profile__extension-options--title">
                {{ $t('page.admin-user-profile.extension-title') }}
              </div>
              <div class="page-admin-user-profile__extension-options--subtitle">
                {{ $t('page.admin-user-profile.extension-subtitle') }}
              </div>
              <BaseButton @click.native="openExtensionOptions" has-icon-right>
                {{ $t('page.admin-user-profile.extension-button') }}
                <BaseIcon name="external-link" />
              </BaseButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon';
import BaseLoadingBar from '@/components/base/BaseLoadingBar';
import LargeNotice from '@/components/notice/LargeNotice';
import PreferencesBasicInfo from '@/components/page-admin-user-profile/PreferencesBasicInfo';
import PreferencesForm from '@/components/page-admin-user-profile/PreferencesForm';
import PreferencesPasswordForm from '@/components/page-admin-user-profile/PreferencesPasswordForm';
import BaseButton from '@/components/base/BaseButton';
import { tenantHasChromeExtensionAccess } from '@/util/module-access-util';

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'pageAdminUserProfile',
  components: {
    BaseIcon,
    BaseLoadingBar,
    LargeNotice,
    PreferencesBasicInfo,
    PreferencesForm,
    PreferencesPasswordForm,
    BaseButton,
  },
  computed: {
    ...mapGetters('auth', ['currentUser']),
    ...mapGetters('tenant', ['tenant']),
    ...mapGetters('userPreferences', ['pending', 'userPreferences', 'error']),
    extensionId() {
      return localStorage.getItem('aloha-extension') || localStorage.getItem('aloha_extension_id') || '';
    },
  },
  methods: {
    ...mapActions('userPreferences', ['getUserPreferences']),
    tenantHasChromeExtensionAccess,
    refresh() {
      location.reload();
    },
    openExtensionOptions() {
      window.postMessage({ action: 'alohaExtensionOpenOptions' }, '*');
    },
  },
  async created() {
    await this.getUserPreferences();
  },
};
</script>

<style lang="scss">
.page-admin-user-profile {
  &__main {
    padding: 32px;
  }

  &__content {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  &__basic-form {
    display: flex;
    width: 45%;
    max-width: 650px;
    min-width: 400px;
    margin-right: 32px;
    margin-bottom: 32px;
  }

  &__basic-form-content {
    width: 100%;
  }

  &__password-form {
    display: flex;
    flex-direction: column;
    width: 45%;
    max-width: 650px;
    min-width: 400px;
    margin-bottom: 72px;
  }

  &__extension-card {
    padding: 24px;
    background: $color-white;
    border-radius: $border-radius-root;
    box-shadow: $shadow-default;
    margin-bottom: 32px;
  }

  &__card-title {
    color: $color-normal;
    font-size: $font-size-xbigger;
    font-weight: bold;
    font-family: $font-family-raleway;
  }

  &__extension-options {
    margin-top: 16px;
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: $color-neutral-pale;
    border-radius: 16px;

    .base-button {
      width: max-content;
    }

    &--title {
      font-size: 20px;
      font-weight: 600;
      color: $color-normal;
      margin-bottom: 8px;
    }

    &--subtitle {
      margin-bottom: 16px;
    }
  }

  @media screen and (max-width: 948px) {
    &__password-form,
    &__basic-form {
      width: 100%;
      margin-right: 0px;
      min-width: auto;
    }
  }
}
</style>
